<template>
    <div>
        <common-table :url="url" :table-columns="tableColumns" :form-fields="formFields" :operate="operate" :permission="permission" :searchs="searchs" ref="table"></common-table>

        <!--编辑模态框-->
        <div class="dialog">
            <el-dialog title="结算" :visible.sync="settleVisible" custom-class="common-dialog" :close-on-click-modal="false">
                <div class="dialog_body">
                    <el-form label-position="right" status-icon :label-width="formFields.labelWidth ? formFields.labelWidth:'80px'"
                             :model="settle" ref="settleForm">

                        <el-form-item label="结算收益" prop="settleEarnings" :rules="[{
                            message: '请输入结算收益', trigger: 'blur', required: true
                        }]">
                            <el-input size="medium" v-model="settle.settleEarnings" autocomplete="off" placeholder="请输入结算收益"></el-input>
                        </el-form-item>

                        <el-form-item label="结算订单金额" prop="settleOrderMoney" :rules="[{
                            message: '请输入结算收益', trigger: 'blur', required: true
                        }]">
                            <el-input size="medium" v-model="settle.settleOrderMoney" autocomplete="off" placeholder="请输入结算订单金额"></el-input>
                        </el-form-item>

                        <el-form-item label="结算订单数量" prop="settleOrderCount" :rules="[{
                            message: '请输入结算收益', trigger: 'blur', required: true
                        }]">
                            <el-input size="medium" v-model="settle.settleOrderCount" autocomplete="off" placeholder="请输入结算订单数量"></el-input>
                        </el-form-item>

                    </el-form>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="settleVisible = false">取 消</el-button>
                    <el-button type="primary" size="small" @click="settleData('settleForm')">结 算</el-button>
                </div>
            </el-dialog>
        </div>

    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    import message from "../../utils/message";
    import request from  "@/utils/axios.js";

    export default {
        name: "UserData",
        components: {CommonTable},
        data(){
            return{
                settleVisible: false,
                settle: {
                    settleEarnings: 0,
                    settleOrderMoney: 0,
                    settleOrderCount: 0
                },
                searchs:[
                    {
                        name: 'username',
                        placeholder: '用户名',
                        type: 'input'
                    },
                    {
                        name: 'status',
                        placeholder: '状态',
                        type: 'select',
                        selectValue: [
                            {
                                key: 0,
                                value: '未结算'
                            },{
                                key: 1,
                                value: '已结算'
                            }
                        ]
                    },
                    {
                        name: 'startTime',
                        placeholder: '开始时间',
                        type: 'dateTime'
                    },
                    {
                        name: 'endTime',
                        placeholder: '结束时间',
                        type: 'dateTime'
                    }
                ],
                permission:{
                    add: 'userData:add',
                    update: 'userData:update',
                    delete: 'userData:delete',
                    deleteBatch: 'userData:deleteBatch'
                },
                url: {
                    get: '/userData/listByCondition',
                    //add: '/userSetting/add',
                    //update: '/userSetting/update',
                    //delete: '/userSetting/delete/',
                    //delete_batch: '/userSetting/deleteBatch',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'ID',
                    show: true,
                    width: '75',
                },{
                    field: 'date',
                    label: '日期',
                    show: true,
                    width: '',
                },{
                    field: 'userNick',
                    label: '用户昵称',
                    show: true,
                    width: '',
                },{
                    field: 'earnings',
                    label: '收益',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'orderMoney',
                    label: '订单金额',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'orderCount',
                    label: '订单数量',
                    show: true,
                    width: '',
                },{
                    field: 'settleEarnings',
                    label: '结算收益',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'settleOrderMoney',
                    label: '结算订单金额',
                    show: {
                        type: 'money'
                    },
                    width: '',
                },{
                    field: 'settleOrderCount',
                    label: '结算订单数量',
                    show: true,
                    width: '',
                },{
                    field: 'status',
                    label: '状态',
                    show: {
                        type: 'tag',
                        tags:[
                            {
                                key: 1,
                                value: '已结算',
                                type: 'success'
                            },{
                                key: 0,
                                value: '未结算',
                                type: 'warning'
                            }
                        ]
                    },
                    width: '',
                },{
                    field: 'updateNick',
                    label: '操作人',
                    show: true,
                    width: '',
                },{
                    field: 'finishTime',
                    label: '结算时间',
                    show: true,
                    width: '',
                }],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    labelWidth: '105px',
                    model: [
                    ],
                },
                operate: [{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '结算',
                    handle: (row) => {
                        console.log(row)
                        if (row.status != 0){
                            message.warning("已结算，不可重复结算");
                            return;
                        }
                        this.settle.settleEarnings = row.earnings;
                        this.settle.settleOrderMoney = row.orderMoney;
                        this.settle.settleOrderCount = row.orderCount;
                        this.settle.id = row.id;
                        this.settleVisible = true;
                    }
                }]
            }
        },
        methods:{
            settleData(settleForm){
                this.$refs[settleForm].validate((valid) => {
                    if (valid) {
                        request.post({
                            url: '/userData/settle',
                            data: this.settle,
                            confirm: '确定结算？',
                            success: (data) => {
                                if (data.code == 0){
                                    message.success("操作成功");
                                    this.settleVisible = false;
                                    this.$refs.table.getData();
                                }else {
                                    message.error(data.msg || "操作失败");
                                }
                            }
                        });
                    }else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
